import { render, staticRenderFns } from "./baseInformation.vue?vue&type=template&id=6729e710&scoped=true&"
import script from "./baseInformation.vue?vue&type=script&lang=js&"
export * from "./baseInformation.vue?vue&type=script&lang=js&"
import style0 from "./baseInformation.vue?vue&type=style&index=0&id=6729e710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6729e710",
  null
  
)

export default component.exports